/** Pet needs finder (F7-39) storefront texts (en). */
export const storefrontNeedsEn = {
  title: "My Pet's Needs",
  metaDescription:
    "A daily care routine suggestion based on your pet's species, age and needs, in a few questions. It does not replace a veterinary examination.",
  lead: 'Answer a few questions and we will suggest a daily care routine for your pet.',
  privacy: 'Your answers stay in this browser only; they are not sent to us.',
  disclaimer: 'This suggestion does not replace a veterinary examination.',
  start: 'Start',
  steps: {
    species: 'Species',
    basics: 'Basics',
    areas: 'Support areas',
    questions: 'Questions',
    result: 'Result',
  },
  progress: 'Progress',
  stepOf: 'Step {{n}} of {{total}}',
  speciesQuestion: 'Which one is your pet?',
  basicsQuestion: "Let's get to know your pet",
  age: 'Age',
  ages: { baby: 'Baby', young: 'Young', adult: 'Adult', senior: 'Senior' },
  weight: 'Weight',
  weights: {
    under_2: 'Under 2 kg',
    '2_5': '2–5 kg',
    '5_10': '5–10 kg',
    '10_25': '10–25 kg',
    over_25: 'Over 25 kg',
  },
  neutered: 'Neutered or spayed?',
  neuteredOptions: { yes: 'Yes', no: 'No', unknown: "I don't know" },
  reproductive: 'Pregnant or nursing?',
  reproductiveOptions: { none: 'No', pregnant: 'Pregnant', lactating: 'Nursing', unknown: "I don't know" },
  areasQuestion: 'What are you looking for support with?',
  multipleHint: 'You can choose more than one.',
  noAreas: 'No support areas have been set up for this species yet.',
  browseSpecies: 'Browse products for {{species}}',
  back: 'Back',
  next: 'Continue',
  seeResult: 'See the result',
  restart: 'Start over',
  change: 'Change',
  answerRequired: 'Make a choice to continue.',
  resultTitle: 'Suggested routine for your pet',
  resultLead: 'We suggest {{count}} products; you can take out any you do not want.',
  why: 'Why it is suggested',
  usage: 'Usage',
  include: 'In routine',
  includeLabel: '{{name}} in routine',
  alternativeFor: 'The suggested product is out of stock, so this one is shown instead.',
  option: 'Option: {{name}}',
  otherOptions: 'Other options on the product page',
  total: 'Total',
  totalNote: '{{count}} products selected. Shipping and promotions are calculated in the cart.',
  addAll: 'Add all to cart',
  adding: 'Adding to cart…',
  added: '{{count}} products added to the cart.',
  goCart: 'Go to cart',
  addFailed: 'Could not add {{name}} to the cart: {{error}}',
  nothingSelected: 'Select at least one product to add to the cart.',
  empty: 'We could not find products matching your answers.',
  emptyLead: 'You can choose another support area or browse all products.',
  browseAll: 'Browse all products',
  emergencyTitle: 'Please contact a veterinarian first',
  emergencyText:
    'The situation you selected may need urgent care. We do not suggest products in this case; please contact a veterinarian without delay.',
  emergencyLinks: 'Pages that can help',
  emergencyBack: 'Change my answer',
  bundle: 'Promotion valid for this routine',
  answersTitle: 'Your answers',
  summary: {
    title: 'Routine summary',
    empty: 'Suggestions appear here as you answer the questions.',
    show: 'See routine ({{count}})',
    pending: 'Questions left: {{count}}',
  },
  chat: {
    greeting: "Hello! Let's put together a care routine for your pet with a few short questions.",
    log: 'Questions and your answers',
    question: 'Question',
    answer: 'Your answer',
    edit: 'Change answer',
    resultIntro: 'The routine we suggest based on your answers:',
    fixed: 'These questions are fixed and answered with the same rules for every visitor.',
  },
  savePet: {
    title: 'Save my pet',
    lead: 'Save the basics to your account so you do not have to enter them again. Answers to health questions are not saved.',
    name: "Your pet's name",
    consent:
      "I give my explicit consent for my pet's species, age, weight range, neutering and pregnancy/nursing information and the support areas I chose to be stored in my account and used to show me suggestions. I can delete this record at any time on the My account page.",
    save: 'Save my pet',
    saved: 'Your pet has been saved.',
    login: 'Sign in to save',
  },
  pets: {
    title: 'My saved pets',
    lead: 'Basics you saved with your explicit consent in the needs finder.',
    use: 'Start for {{name}}',
    unnamed: 'My {{species}}',
    delete: 'Delete',
    deleteLabel: 'Delete the record of {{name}}',
    deleted: 'Record deleted.',
    empty: 'You have no saved pets.',
    open: 'Open the needs finder',
  },
  seed: {
    reason: 'For the “{{area}}” support area you selected.',
    emergencyQuestion: 'Does your pet have any of the following right now?',
    emergencyHelp: 'If so, we do not suggest products; please contact a veterinarian first.',
    emergencyNone: 'None of these',
    emergency: {
      breathing: 'Struggling to breathe',
      bleeding: 'Bleeding that does not stop',
      poison: 'May have eaten or licked something poisonous',
      seizure: 'Having a seizure',
      collapse: 'Collapsed or cannot stand up',
      not_eating: 'Not eating or drinking at all for more than a day',
    },
    pregnancyNote: "The product's warning text mentions pregnancy or nursing.",
    intro:
      "Choose your pet's species, age and the topics you want support with; we will suggest a suitable daily care routine.",
    emergencyText:
      'The situation you selected may need urgent care. We do not suggest products in this case; please contact a veterinarian without delay.',
  },
};
